import { styled } from "@mui/material/styles";

const OrText = styled("div")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "22px",
  textAlign: "center",
  color: "rgba(11, 11, 11, 0.5)",
  marginBottom: "20px",
}));

export { OrText };
